import { useEffect } from "react";
const defaultTitle = 'Custom Plates | Personalised Plates Victoria';

export default function useTitle(title) {
    useEffect(() => {
        if (title) document.title = title;
        return () => {
            document.title = defaultTitle;
        };
    }, [title]);
}       